/* eslint-disable react/prop-types */
import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { isArrayEqual } from '../utils/array';

const OptionManager = ({ product, dispatch }) => {
  // calculate possible values for all checkboxes
  const calcOptions = () => {
    const variants = product.variants;
    const calculatedOptions = [];
    for (let index = 0; index < variants[index].options.length; index++) {
      calculatedOptions.push({
        name: product.options[index],
        options: Array.from(
          new Set(variants.map((variant) => variant.options[index]))
        ), // this ensures there are only unique values
      });
    }
    return calculatedOptions;
  };

  // when selection is changed, update the values
  const updateSelections = (e) => {
    const [optionName, optionValue] = e.target.value.split('|');
    setSelection(
      selection.map((choice) => {
        if (choice.name == optionName) choice.value = optionValue;
        return choice;
      })
    );
  };

  // set state variables as needed
  const [options] = useState(() => {
    return calcOptions(product);
  });
  const [selection, setSelection] = useState(() =>
    options.map((option) => ({ name: option.name, value: option.options[0] }))
  );

  // when selection changes- dispatch an update
  useEffect(() => {
    const selectionArr = selection.map((choice) => choice.value);
    const newVariant = product.variants.find((variant) =>
      isArrayEqual(selectionArr, variant.options)
    );
    dispatch({
      type: 'CHANGE_VARIANT',
      payload: newVariant,
    });
  }, [selection]);

  return (
    <div className={`${options.length == 1 ? '' : 'two-split'}`}>
      {options.map((option) => {
        return (
          <div key={option.name}>
            <p>Select a {option.name}</p>
            <select style="width: 100%;" onChange={updateSelections}>
              {option.options.map((choice) => (
                <option key={choice} value={`${option.name}|${choice}`}>
                  {choice}
                </option>
              ))}
            </select>
          </div>
        );
      })}
    </div>
  );
};

export default OptionManager;
